<template>
  <div class="login-step login-step-username">
    <div class="step-title">{{ $t('lbl_emp2_SupplierLoginHere') }}</div>

    <div class="form-group username-group">
      <div class="input-field-wrapper">
        <div class="input-field-container">
          <div 
            class="input-container"
            :class="{ 'input-error': usernameError }"
          >
            <!-- 输入框内容区域 -->
            <div class="input-inner">
              <div class="input-text-wrapper">
                <!-- 正常状态下的占位符 -->
                <template v-if="!username && !usernameError">
                  <span class="input-placeholder-text">{{ $t('lbl_emp2_AccountName') }}</span><span class="input-placeholder-space"> </span><span class="input-placeholder-required">*</span>
                </template>
                <input
                  id="username-field"
                  :value="username"
                  type="text"
                  name="username"
                  autocomplete="username"
                  class="form-input"
                  :class="{ 'input-error': usernameError }"
                  placeholder=""
                  @focus="$emit('clear-error')"
                  @input="handleInput"
                  @keydown.enter.prevent="handleEnter"
                />
              </div>
              <div
                class="input-icon-wrapper"
                tabindex="0"
                @mouseenter="$emit('update:showTooltip', true)"
                @mouseleave="$emit('update:showTooltip', false)"
                @focus="$emit('update:showTooltip', true)"
                @blur="$emit('update:showTooltip', false)"
              >
                <div class="input-icon"></div>
              </div>
            </div>
          </div>
          <!-- Tooltip 显示在输入框旁边（右侧） -->
          <div v-if="showTooltip" class="login-custom-tooltip">
            <div class="tooltip-wrapper">
              <div class="login-tooltip-arrow"></div>
              <div class="login-tooltip-content">
                <div class="tooltip-text">
                  {{ $t('lbl_emp2_IfExhibitorCHINAPLAS') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 错误信息 -->
        <div v-if="usernameError" class="username-error-message">
          {{ $t('lbl_emp2_InvalidAccountName') }}
        </div>
      </div>
      <div class="forgot-link-wrapper">
        <a href="#" @click.prevent="$emit('show-forgot-username')" class="forgot-link">{{ $t('lbl_emp2_ForgotAccountName') }}</a>
      </div>
    </div>

    <button
      class="btn-primary btn-continue-username username-continue-btn"
      @click="$emit('continue')"
      :disabled="!username || loading"
      t_label="btn_emp2_Continue_UsernameStep"
    >
      {{ $t('lbl_emp2_Continue') }}
    </button>

    <slot name="divider">
      <div class="divider">
        <span>{{ $t('lbl_emp2_OR') }}</span>
      </div>
    </slot>

    <slot name="alternative-login">
      <div class="alternative-login">
        <button class="btn-secondary btn-with-indicator" @click="$emit('switch-login', 'mobile')" t_label="btn_emp2_LoginWithMobile_FromUsername">
          {{ $t('lbl_emp2_LoginWithMobile') }}
        </button>
        <button class="btn-secondary btn-with-indicator" @click="$emit('switch-login', 'email')" t_label="btn_emp2_LoginWithEmail_FromUsername">
          {{ $t('lbl_emp2_LoginWithEmail') }}
        </button>
      </div>
    </slot>

    <!-- SSO 登录暂时隐藏 -->
    <!-- <slot name="sso-login">
      <div class="sso-login">
        <button class="sso-btn wechat" @click="$emit('wechat-login')" title="Login with WeChat">
          <img src="https://cdn.adsalecdn.com/EMP/Backend/Images/wechat_icon.png" alt="WeChat" />
        </button>
        <button class="sso-btn google" @click="$emit('google-login')" title="Login with Google">
          <img src="https://cdn.adsalecdn.com/EMP/Backend/Images/google_icon.png" alt="Google" />
        </button>
        <button class="sso-btn linkedin" @click="$emit('linkedin-login')" title="Login with LinkedIn">
          <img src="https://cdn.adsalecdn.com/EMP/Backend/Images/linkedin_icon.png" alt="LinkedIn" />
        </button>
      </div>
    </slot> -->

    <slot name="become-supplier">
      <div class="become-supplier">
        <span>{{ $t('lbl_emp2_NotASupplierMember') }}</span>
        <a
          href="#"
          @click.prevent="$emit('show-become-supplier')"
          class="supplier-link"
        >
          {{ $t('lbl_emp2_ApplyForMembership') }} →
        </a>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'UsernameStep',
  props: {
    username: {
      type: String,
      default: ''
    },
    usernameError: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    showTooltip: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleInput(event) {
      const value = event.target.value.replace(/\s/g, '');
      event.target.value = value;
      this.$emit('update:username', value);
      this.$emit('clear-username-error');
    },
    handleEnter() {
      if (this.loading || !this.username) {
        return;
      }
      this.$emit('continue');
    }
  }
};
</script>

<style scoped>
.login-step-username {
  gap: 24px !important;
}

.step-title {
  color: rgba(0, 0, 0, 0.80);
  font-size: 28px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  line-height: 36.40px;
  margin: 0;
  word-wrap: break-word;
}

@media (max-width: 768px) {
  .step-title {
    font-size: 24px;
    line-height: 31.20px;
  }
}

.form-group {
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;
  gap: 16px;
}

.form-group.username-group {
  gap: 16px !important;
}

.input-field-wrapper {
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 4px;
  display: flex;
}

.input-field-container {
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;
  position: relative;
}

.input-container {
  align-self: stretch;
  padding-left: 12px;
  padding-right: 12px;
  border-radius: 4px;
  outline: 1px rgba(0, 0, 0, 0.23) solid;
  outline-offset: -1px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;
  position: relative;
  overflow: visible;
}

.input-container.input-error {
  outline-color: #CD1515 !important;
}

.input-inner {
  align-self: stretch;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 12px;
  padding-right: 12px;
  overflow: hidden;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: inline-flex;
}

.input-text-wrapper {
  flex: 1 1 0;
  justify-content: center;
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 24px;
}

.input-placeholder-text,
.input-placeholder-space,
.input-placeholder-required {
  display: inline;
  vertical-align: baseline;
}

.input-placeholder-text,
.input-placeholder-space {
  color: rgba(0, 0, 0, 0.60);
  font-size: 14px;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
  word-wrap: break-word;
}

.input-placeholder-required {
  color: #CD1515;
  font-size: 14px;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
  word-wrap: break-word;
}

.form-input {
  width: 100%;
  border: none;
  background: transparent;
  font-size: 14px;
  font-family: 'Roboto', sans-serif;
  color: rgba(0, 0, 0, 0.80);
  line-height: 24px;
  letter-spacing: 0.15px;
  padding: 0;
  outline: none;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
}

.form-input:focus {
  outline: none;
  border: none;
  background: transparent;
}

.form-input.input-error {
  border: none !important;
}

.required {
  color: #CD1515;
  font-size: 14px;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
  margin-left: 4px;
}

.input-icon-wrapper {
  width: 24px;
  height: 24px;
  position: relative;
  cursor: pointer;
  flex-shrink: 0;
}

.input-icon {
  width: 20px;
  height: 20px;
  left: 2px;
  top: 2px;
  position: absolute;
  background: transparent;
  border-radius: 50%;
}

.login-custom-tooltip {
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 99999;
  pointer-events: none;
  display: flex;
  align-items: flex-start;
}

/* 响应式：在手机版本中向左移动 30% */
@media (max-width: 768px) {
  .login-custom-tooltip {
    left: 50%;
    transform: translateX(-80%);
  }
}

.tooltip-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-shadow: 0px 2px 15px rgba(183, 183, 183, 0.30);
  position: relative;
  min-width: 280px;
  max-width: 300px;
  background: #FFFFFF;
}

.login-tooltip-arrow {
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #FFFFFF;
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  filter: drop-shadow(0px 2px 2px rgba(183, 183, 183, 0.30));
}

/* 在手机版，tooltip 向左偏移 30% 时，箭头向右偏移相同距离以保持对齐 icon 中心 */
@media (max-width: 768px) {
  .login-tooltip-arrow {
    left: calc(50% + 30%);
    transform: translateX(-50%);
  }
}

.login-tooltip-content {
  width: 100%;
  padding: 12px 12px 12px 16px;
  background: #FFFFFF !important;
  background-color: #FFFFFF !important;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
}

.tooltip-text {
  width: 100%;
  color: rgba(0, 0, 0, 0.60);
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  line-height: 18.20px;
  word-wrap: break-word;
  text-align: left;
}

.username-error-message {
  padding-left: 14px;
  padding-right: 14px;
  color: #D32F2F;
  font-size: 12px;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  letter-spacing: 0;
  word-wrap: break-word;
}

.forgot-link-wrapper {
  align-self: stretch;
  justify-content: flex-start;
  align-items: center;
  gap: 0;
  display: inline-flex;
}

.forgot-link {
  color: rgba(0, 0, 0, 0.40) !important;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  line-height: 14px;
  text-decoration: none !important;
}

.btn-primary {
  width: 100%;
  padding: 16px 24px !important;
  background: #7366FF !important;
  color: white !important;
  border: none !important;
  border-radius: 999px !important;
  font-size: 14px !important;
  font-family: 'Inter', sans-serif !important;
  font-weight: 600 !important;
  line-height: 14px !important;
  cursor: pointer !important;
  transition: all 0.2s !important;
}

.btn-primary:hover:not(:disabled) {
  background: #5a4dcc !important;
  color: white !important;
  border: none !important;
}

.btn-primary:disabled {
  opacity: 0.6 !important;
  cursor: not-allowed !important;
  background: #B8B3FF !important;
  color: rgba(255, 255, 255, 0.9) !important;
}

.divider {
  display: flex;
  align-items: center;
  gap: 24px;
  margin: 0;
}

.divider::before,
.divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: rgba(0, 0, 0, 0.10);
}

.divider span {
  color: rgba(0, 0, 0, 0.50);
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  line-height: 14px;
}

.alternative-login {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0;
  padding: 0;
}

.btn-secondary {
  align-self: stretch;
  height: 42px;
  padding: 0 24px;
  border-radius: 999px;
  outline: 1px rgba(0, 0, 0, 0.60) solid;
  outline-offset: -1px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: inline-flex;
  background: white !important;
  background-color: white !important;
  border: none !important;
  cursor: pointer;
  transition: all 0.2s;
  color: rgba(0, 0, 0, 0.80);
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  line-height: 14px;
  word-wrap: break-word;
  box-sizing: border-box;
}

.btn-secondary:hover {
  background: rgba(0, 0, 0, 0.03) !important;
  background-color: rgba(0, 0, 0, 0.03) !important;
  outline-color: rgba(0, 0, 0, 0.60);
}

.sso-login {
  width: 100%;
  display: flex;
  gap: 10px;
  justify-content: center;
}

.sso-btn {
  flex: 1 1 0;
  height: 74px;
  background: rgba(0, 0, 0, 0.03);
  border: none;
  border-radius: 999px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.sso-btn:hover {
  background: rgba(0, 0, 0, 0.06);
}

.sso-btn svg,
.sso-btn img {
  width: 45px;
  height: 45px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  object-fit: contain;
}

.become-supplier {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
}

.become-supplier span {
  color: rgba(0, 0, 0, 0.60);
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  line-height: 18.2px;
}

.supplier-link {
  color: #7366FF;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  line-height: 18.2px;
  text-decoration: none;
}
</style>

<!-- 全局样式覆盖 -->
<style>
/* 引入共享样式 */
@import '../Common/new-login-shared.css';

.alternative-login .btn-secondary {
  background: white !important;
  background-color: white !important;
  border: none !important;
  color: rgba(0, 0, 0, 0.80) !important;
}

.alternative-login .btn-secondary:hover {
  background: rgba(0, 0, 0, 0.03) !important;
  background-color: rgba(0, 0, 0, 0.03) !important;
  color: rgba(0, 0, 0, 0.80) !important;
}
</style>

